export default __webpack_public_path__ + "static/media/sales.85c61de0.png";